<template>
  <section>
    <errors-list :errorMessage="errorMessage" />

    <v-data-table
      :headers="translatedHeaders"
      :items="items"
      :loading="loading"
      :rows-per-page-items="rowsPerPageItems"
    >
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr>
          <template v-for="(header, index) in translatedHeaders">
            <td :key="index" v-if="header.value === 'selected'">
              <v-checkbox v-model="props.item.selected" hide-details class="justify-end layout" />
            </td>

            <td :key="index" v-else-if="header.value === 'contractInternalId'">
              <v-btn
                :href="`/contract/${props.item.insurance.internalId}`"
                target="_blank"
                :outline="true"
                color="green darken-3"
                :small="true"
              >
                {{ props.item.insurance.internalId }}
              </v-btn>
            </td>

            <grid-cell v-else :header="header" :row="props.item" :key="index"></grid-cell>
          </template>
        </tr>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import ErrorsList from '../../components/ErrorsList';
import GridCell from '../../components/GridCell';
import { getErrorMessage } from '../../errorHandlers';
import { createdBy, defaultDateTimeFormatter } from '../../utils';

export const defaultHeaders = [
  {
    text: '@repaymentList/id',
    align: 'left',
    value: 'id',
    sortable: false,
  },
  {
    text: '@repaymentList/created',
    align: 'left',
    sortable: true,
    value: 'createdAt',
    format: defaultDateTimeFormatter,
  },
  {
    text: '@repaymentList/insurance',
    align: 'left',
    value: 'contractInternalId',
    sortable: false,
  },
  {
    text: '@repaymentList/product',
    align: 'left',
    value: 'insurance.product.name',
    sortable: false,
  },
  {
    text: '@repaymentList/status',
    align: 'left',
    value: 'status',
    sortable: false,
  },
  {
    text: '@repaymentList/sum',
    align: 'left',
    value: 'sum',
    sortable: false,
  },
  {
    text: '@repaymentList/numInvoices',
    align: 'left',
    value: 'numInvoices',
    sortable: false,
  },
  { text: '@repaymentList/createdBy', value: 'byEmployee', sortable: false, format: createdBy },
  {
    text: '@repaymentList/select',
    align: 'right',
    sortable: false,
    value: 'selected',
  },
];

export default {
  components: { GridCell, ErrorsList },

  data() {
    return {
      items: [],
      rowsPerPageItems: [10, 20, 50, 100, 200],
      loading: false,
      errorMessage: '',
      statuses: {
        pending: this.$t('@repaymentStatus/pending'),
        repaid: this.$t('@repaymentStatus/repaid'),
        completed: this.$t('@repaymentStatus/completed'),
      },
    };
  },

  mounted() {
    this.fetchData();
  },

  watch: {
    allSelected() {
      this.$emit('allSelected', this.allSelected);
    },

    items: {
      handler() {
        const selectedItems = this.items.filter((item) => item.selected);

        this.$emit('itemsSelected', selectedItems.map((item) => item.id));
      },
      deep: true,
    },
  },

  computed: {
    translatedHeaders() {
      return defaultHeaders.map((h) => ({
        ...h,
        text: this.$t(h.text),
      }));
    },

    allSelected() {
      return this.items.every((item) => item.selected);
    },
  },

  methods: {
    selectAll() {
      const allSelected = this.allSelected;
      this.items.forEach((item) => (item.selected = !allSelected));
    },

    clearSelection() {
      this.items.forEach((item) => {
        item.selected = false;
      });
    },

    async fetchData() {
      this.clearSelection();

      try {
        this.loading = true;

        // TODO: make sure to fetch everything, shouldn't be more than a couple hundred at most
        const { data } = await this.$http.get(`/api/repayments/pending`);

        const withTranslatedStatuses = data.items.map((item) => ({
          ...item,
          selected: false,
          status: this.statuses[item.status],
        }));

        this.items = withTranslatedStatuses;
        this.errorMessage = '';
      } catch (e) {
        this.errorMessage = getErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
